<template>
  <v-container
    fill-height
    style='max-width:100%;'
  >
    <v-row style='height:100%;'>
      <v-col style='height:100%;padding:0;'>
        <v-card
          flat
          class='card-style'
        >
          <div class='card-style-title'>
            Barriers to cycling
            <div class='btnCont'>
              <iframe-modal
                :id='id'
                :src='src'
                :width='850'
                :height='600'
              />
              <v-btn
                depressed
                rounded
                color='#00486b'
                style='color:#fff'
                width='7em'
                :href='mapDatasetUrls'
                target='_blank'
              >Data</v-btn>
            </div>
          </div>
          <v-container
            v-if='!overlay'
            class='contentHolder'
          >
            <v-container v-if='overlay'>
              <v-overlay
                :absolute='true'
                :value='overlay'
              >
                <v-progress-circular
                  indeterminate
                  size='64'
                ></v-progress-circular>
              </v-overlay>
            </v-container>
            <v-row>
              <v-col
                cols='12'
                xs='12'
                sm='12'
                md='12'
              >
                <div
                  class='description'
                  v-if='results.length > 0'
                >
                  <p>
                    Top six reasons given for not
                    cycling to work in {{ results[0].Year }} (Sample size: 1,570)
                  </p>
                  <p class='source'>
                    <span>
                      Data Source:
                      <a
                        target='_blank'
                        href='https://www.transport.gov.scot/publication/transport-and-travel-in-scotland-2019-results-from-the-scottish-household-survey/table-26a-cycling-reasons-why-do-not-cycle-to-work-2019/'
                      >
                        Transport and Travel in Scotland:
                        Results from the Scottish Household Survey
                      </a>
                    </span>
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class='mainText'>
                <div>
                  <VueSvgGauge
                    :start-angle='0'
                    :end-angle='360'
                    :value='(results[0].Percentage / 100) * 360'
                    :separator-step='0'
                    :min='0'
                    :max='360'
                    :gauge-color='colors[0]'
                    :base-color='colors[1]'
                    :scale-interval='0'
                  >
                    <div class='img-container'>
                      <v-img
                        contain
                        :src='require(`@/assets/images/CS_new_icons_journey.png`)'
                        alt='too long to journey icon'
                        aspect-ratio='1.6'
                      ></v-img>
                    </div>
                  </VueSvgGauge>
                </div>
                <p>
                  <b>{{ results[0].Percentage }}%</b>
                  <br />
                  {{ results[0].Reason }}
                  <br />
                </p>
              </v-col>
              <v-col class='mainText'>
                <div>
                  <VueSvgGauge
                    :start-angle='0'
                    :end-angle='360'
                    :value='(results[1].Percentage / 100) * 360'
                    :separator-step='0'
                    :min='0'
                    :max='360'
                    :gauge-color='colors[0]'
                    :base-color='colors[1]'
                    :scale-interval='0'
                  >
                    <div class='img-container'>
                      <v-img
                        contain
                        :src='require(`@/assets/images/CS_new_icons_distance.png`)'
                        alt='cycling traffic icon'
                        aspect-ratio='1.6'
                      ></v-img>
                    </div>
                  </VueSvgGauge>
                </div>
                <p>
                  <b>{{ results[1].Percentage }}%</b>
                  <br />
                  {{ results[1].Reason }}
                  <br />
                </p>
              </v-col>
              <v-col class='mainText'>
                <div>
                  <VueSvgGauge
                    :start-angle='0'
                    :end-angle='360'
                    :value='(results[2].Percentage / 100) * 360'
                    :separator-step='0'
                    :min='0'
                    :max='360'
                    :gauge-color='colors[0]'
                    :base-color='colors[1]'
                    :scale-interval='0'
                  >
                    <div class='img-container'>
                      <v-img
                        contain
                        :src='require(`@/assets/images/CS_new_icons-weather.png`)'
                        alt='bad weather icon'
                        aspect-ratio='1.6'
                      ></v-img>
                    </div>
                  </VueSvgGauge>
                </div>
                <p>
                  <b>{{ results[2].Percentage }}%</b>
                  <br />
                  {{ results[2].Reason }}
                  <br />
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                class='mainText'
                cols='4'
              >
              <div>
                  <VueSvgGauge
                    :start-angle='0'
                    :end-angle='360'
                    :value='(results[3].Percentage / 100) * 360'
                    :separator-step='0'
                    :min='0'
                    :max='360'
                    :gauge-color='colors[0]'
                    :base-color='colors[1]'
                    :scale-interval='0'
                  >
                    <div class='img-container'>
                      <v-img
                        contain
                        :src='require(`@/assets/images/CS_new_icons_thumbs.png`)'
                        alt='too long to journey icon'
                        aspect-ratio='1.6'
                      ></v-img>
                    </div>
                  </VueSvgGauge>
                </div>
                <p>
                  <b>{{ results[3].Percentage }}%</b>
                  <br />
                  {{ results[3].Reason }}
                  <br />
                </p>
              </v-col>
              <v-col
                class='mainText'
                cols='4'
              >
              <div>
                  <VueSvgGauge
                    :start-angle='0'
                    :end-angle='360'
                    :value='(results[4].Percentage / 100) * 360'
                    :separator-step='0'
                    :min='0'
                    :max='360'
                    :gauge-color='colors[0]'
                    :base-color='colors[1]'
                    :scale-interval='0'
                  >
                    <div class='img-container'>
                      <v-img
                        contain
                        :src='require(`@/assets/images/CS_new_icons_dark.png`)'
                        alt='dark lonely roads concern icon'
                        aspect-ratio='1.6'
                      ></v-img>
                    </div>
                  </VueSvgGauge>
                </div>
                <p>
                  <b>{{ results[4].Percentage }}%</b>
                  <br />
                  {{ results[4].Reason }}
                  <br />
                </p>
              </v-col>
              <v-col
                class='mainText'
                cols='4'
              >
              <div>
                  <VueSvgGauge
                    :start-angle='0'
                    :end-angle='360'
                    :value='(results[5].Percentage / 100) * 360'
                    :separator-step='0'
                    :min='0'
                    :max='360'
                    :gauge-color='colors[0]'
                    :base-color='colors[1]'
                    :scale-interval='0'
                  >
                    <div class='img-container'>
                      <v-img
                        contain
                        :src='require(`@/assets/images/CS_new_icons_luggage.png`)'
                        alt='no way to carry luggage icon'
                        aspect-ratio='1.6'
                      ></v-img>
                    </div>
                  </VueSvgGauge>
                </div>
                <p>
                  <b>{{ results[5].Percentage }}%</b>
                  <br />
                  {{ results[5].Reason }}
                  <br />
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import iframeModal from '@/components/iframeModal.vue';

export default {
  components: {
    iframeModal,
  },
  data() {
    return {
      results: [],
      overlay: true,
      id: 'attitudes',
      src: 'attitudes',
      colors: ['#004a6b', '#d0ecfa'],
    };
  },
  computed: {
    ...mapGetters(['compositeDataset']),
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.attitudesDataset) {
        d = this.compositeDataset.attitudesDataset.dataset;
        this.content(this.compositeDataset.attitudesDataset.apiResource);
      } else {
        console.error('No API Resource: ( attitudes )');
      }
      return d;
    },
  },
  methods: {
    async content(resource) {
      const params = { datasetGUID: resource };
      const newResults = await this.$store.dispatch('fetchData', params);
      this.results = newResults.data;
      this.overlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.gauge {
  width: 5vw;
}

.mainText {
  display: flex;
  flex-direction: row;
  align-items: center;

  p {
    font-weight: bold;
    font-size: 1em;
    margin-left: 15px;

    b {
      font-size: 1.5em;
    }

    span {
      font-size: 0.8em;
      font-style: italic;
    }
  }
}

.contentHolder {
  margin: 10px;
  max-width: 100%;
}

.card-style {
  padding: 2em;
  width: 100%;
  height: 100%;
  justify-content: center;
}

.img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 1em;

  p {
    font-size: 1.2em;
    font-weight: bold;
  }

  .source {
    font-size: 0.8em;
    font-style: italic;
    font-weight: bold;
  }
}
</style>
